// Session passthrough from the vasana-be platform. This app does NOT log anyone
// in. The admin signs in on the platform (email + OTP); vasana-web stores the
// Cognito access token in a cookie scoped to the root domain (e.g. .vasana.com),
// which this subdomain can read. We send that token to the API, which verifies it
// and enforces platform_admin. No platform session → the dashboard sends the
// visitor to the platform login instead of opening.

const COOKIE = process.env.REACT_APP_AUTH_COOKIE || "token";
const COOKIE_DOMAIN = process.env.REACT_APP_AUTH_COOKIE_DOMAIN || "";
// Default place to send visitors who have no platform session. Different admin
// roles sign in on different pages, so the platform also drops the role-appropriate
// login URL in a cookie when it opens the dashboard; we prefer that, so an expired
// org-admin session returns to the org login rather than the platform-admin login.
const PLATFORM_LOGIN_URL = process.env.REACT_APP_PLATFORM_LOGIN_URL || "";
const LOGIN_URL_COOKIE = process.env.REACT_APP_LOGIN_URL_COOKIE || "intel_login_url";

function readCookie(name) {
  const m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return m ? decodeURIComponent(m[1]) : null;
}

export function getToken() {
  return readCookie(COOKIE);
}

// The role-appropriate sign-in page: the URL the platform passed at entry, else the
// configured default. Only http(s) values are honored, so a malformed or unexpected
// cookie can't be used as a redirect target.
function loginUrl() {
  const fromCookie = readCookie(LOGIN_URL_COOKIE);
  if (fromCookie && /^https?:\/\//i.test(fromCookie)) return fromCookie;
  return PLATFORM_LOGIN_URL;
}

export function isAuthed() {
  return !!getToken();
}

// True only when we have somewhere external to send unauthenticated visitors.
export function hasPlatformLoginUrl() {
  return !!loginUrl();
}

export function goToPlatformLogin() {
  const url = loginUrl();
  if (url) {
    window.location.href = url;
  }
}

// Best-effort clear of the shared cookie (no redirect). Used when the session
// ends and we just want the stale token gone locally.
export function clearToken() {
  const dom = COOKIE_DOMAIN ? "; domain=" + COOKIE_DOMAIN : "";
  document.cookie = COOKIE + "=; Max-Age=0; path=/" + dom;
}

export function logout() {
  // Clear the shared cookie, then back to the platform login.
  clearToken();
  goToPlatformLogin();
}
